export default __webpack_public_path__ + "static/bgimage-e07a2665b87d44731302132d8831c539.jpg";